import Stripe from 'stripe';

export type StripePaymentMethod = Stripe.CustomerSource | Stripe.PaymentMethod;

export enum StripeElementsLayout {
  Tabs = 'tabs',
  Accordion = 'accordion',
}
